const links = document.querySelectorAll('.partnership--link');

// Helper to hide all target elements
function hideAllTargets() {
  links.forEach(link => {
    const href = link.getAttribute("href");
    if (href) {
      const cls = href.replace(/^\./, "");
      document.querySelectorAll(`.${cls}`).forEach(tgt => tgt.setAttribute("hidden", "true"));
    }
  });
}

// Initialize
if (links.length > 0) {
  hideAllTargets(); // hide everything first

  const firstLink = links[0];
  const href = firstLink.getAttribute("href");
  if (href) {
    const cls = href.replace(/^\./, "");
    document.querySelectorAll(`.${cls}`).forEach(tgt => tgt.removeAttribute("hidden"));
  }
  links.forEach(link => link.classList.remove("active"));
  firstLink.classList.add("active");
}

// Handle clicks
links.forEach(link =>
  link.addEventListener("click", e => {
    e.preventDefault();
    const href = link.getAttribute("href");
    if (href) {
      hideAllTargets();
      const cls = href.replace(/^\./, "");
      document.querySelectorAll(`.${cls}`).forEach(tgt => tgt.removeAttribute("hidden"));
      links.forEach(l => l.classList.remove("active"));
      link.classList.add("active");

      if (window.innerWidth <= 749) {
        setTimeout(() => {
          link.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    }
  })
);

function scrollToHash() {
  const hash = window.location.hash; // "#faq"
  if (hash) {
    const id = hash.slice(1); // remove #
    const target = document.querySelector(`[data-section-id="${id}"]`);
    if (target) {
      let offset = 0;
      const stickyHeader = document.querySelector('.header[data-sticky-state="active"]');
      if (stickyHeader) {
        offset = stickyHeader.clientHeight;
      }

      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth"
      });
    }
  }
}

// Run on page load
scrollToHash();

// Run on hash change
window.addEventListener("hashchange", scrollToHash);

// Run when clicking hash link (even if it includes slash or full URL)
document.querySelectorAll('a[href]').forEach(link => {
  link.addEventListener("click", event => {
    const linkUrl = new URL(link.href, window.location.href);

    if (
      linkUrl.pathname === window.location.pathname && // same page
      linkUrl.hash // has a hash
    ) {
      event.preventDefault();
      history.pushState(null, null, linkUrl.hash);
      scrollToHash();
    }
  });
});

const headerGroup = document.getElementById("header-group");

function updateGroupHeight() {
  if (!headerGroup) return;
  const totalHeight = Array.from(headerGroup.children)
    .reduce((sum, el) => sum + el.clientHeight, 0);

  document.documentElement.style.setProperty("--group-height", `${totalHeight}px`);
}

// Run on load
updateGroupHeight();

// Update on resize
window.addEventListener("resize", updateGroupHeight);